import { ModalTitleResult } from '../types';
import { buildPageTitleUrl } from './pageTitleUrl';

export class BackOnReferer {
	private refererButtonDesktop = document.querySelector<HTMLLinkElement>('.backOnReferer.desktop');
	private refererButtonMobile = document.querySelector<HTMLLinkElement>('.backOnReferer.mobile');

	/**
	 * Initializes the EventFilter.
	 *
	 * @returns void
	 */
	init() {
		if (this.refererButtonDesktop == null) return;
		if (this.refererButtonMobile == null) return;

		if (document.referrer.includes(window.location.hostname)) {
			this.fetchRefererTitle();

			[this.refererButtonMobile, this.refererButtonDesktop].forEach((ref) =>
				ref.addEventListener('click', (event) => {
					event.preventDefault();

					history.back();
				})
			);
		} else {
			// Set href to homepage to avoid confusion
			this.refererButtonMobile.href = window.location.origin;
			this.refererButtonMobile.classList.remove('hidden');

			this.refererButtonDesktop.href = window.location.origin;
			this.refererButtonDesktop.classList.remove('hidden');
		}
	}

	private fetchRefererTitle() {
		const languageUid = document.querySelector<HTMLSpanElement>('span.language-uid')?.innerText ?? '0';

		const options = {
			method: 'POST',
			body: JSON.stringify({ referer: document.referrer, languageUid: languageUid }),
		};

		fetch(buildPageTitleUrl(window.location), options)
			.then((data): Promise<ModalTitleResult> => {
				return data.json();
			})
			.then((data) => {
				if (data.error !== 0) throw new Error('Something went wrong fetching modal title');

				this.refererButtonDesktop!.innerText = data.pageTitle;
				[this.refererButtonMobile, this.refererButtonDesktop].forEach((ref) => ref!.classList.remove('hidden'));
			})
			.catch((err) => {
				console.error(err);

				// In case of an error, we still want to show the Back button
				[this.refererButtonMobile, this.refererButtonDesktop].forEach((ref) => ref!.classList.remove('hidden'));
			});
	}
}
